import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterNewBusinessComponent} from "./register-new-business.component";

const routes: Routes = [
  {path: '', component: RegisterNewBusinessComponent},
  {path: ':id', component: RegisterNewBusinessComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterNewBusinessRoutingModule { }
